import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';

import { CollapseBoxComponent } from '@common/collapse-box/collapse-box.component';
import { ReMultipleSelectModule } from '@common/re-multi-select/re-multiselect.module';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { AlterComponent } from '../common/alter/alter.component';
import { BreadcrumbsComponent } from '../common/breadcrumbs/breadcrumbs.component';
import { ConfirmationDialogComponent } from '../common/confirmation-dialog/confirmation-dialog.component';
import { EditUserImagesComponent } from '../modules/setting/manage-user-contacts/user/edit-user/edit-user-images/edit-user-images.component';
import { PipeDirectiveModule } from './pipe-directive.module';
import { InputSwitchModule } from 'primeng/inputswitch';

const ComponentList = [CollapseBoxComponent, ConfirmationDialogComponent, AlterComponent, EditUserImagesComponent, BreadcrumbsComponent];

@NgModule({
  declarations: [...ComponentList],
  imports: [
    CommonModule,
    PipeDirectiveModule,
    TableModule,
    TooltipModule,
    ImageCropperModule,
    CheckboxModule,
    ReMultipleSelectModule,
    InputSwitchModule,
  ],
  exports: [...ComponentList, PipeDirectiveModule],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CommonSharedModule {}
